import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../components/base/BasicDialog";
import { OfferReadOnlyButton } from "../../components/buttons/OfferReadOnlyButton";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { extractProductDiscountsFromBooking } from "../../utils/bookingUtils";
import { AgreementConfigurationDialog } from "../AgreementsPage/AgreementConfigurationDialog/AgreementConfigurationDialog";
import BookingCancellationDialog from "./BookingCancellationDialog";
import { BookingEditDialog } from "./BookingEditDialog";

export const BookingManageDialog = (props) => {
    const { open, onClose, booking } = props;
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const openCancelBookingDialog = () => {
        openDialog({
            Component: BookingCancellationDialog,
            componentProps: {
                bookingId: booking.id,
                onSuccess: onClose,
            },
        });
        onClose();
    };

    const openBookingEditDialog = () => {
        openDialog({
            Component: BookingEditDialog,
            componentProps: {
                initialBooking: booking,
                onSuccess: onClose,
            },
        });
        onClose();
    };

    const handleTransformToAgreement = () => {
        const customerIds = booking.customers.map((bc) => bc.customer.id);
        const productIds = booking.products.map((p) => p.id);
        const productDiscounts = extractProductDiscountsFromBooking(booking);

        openDialog({
            Component: AgreementConfigurationDialog,
            componentProps: {
                initialCustomerIds: customerIds,
                initialProductIds: productIds,
                initialProductDiscounts: productDiscounts,
                sourceBookingId: booking.id,
            },
        });
        onClose();
    };

    return (
        // @ts-ignore
        <BasicDialog
            open={open}
            onClose={onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("bookings.BookingManageDialog.title")}
            maxWidth={"sm"}
            showDialogActions
        >
            <Grid container direction="column" spacing={2} sx={{ mt: 1 }}>
                <Grid item container spacing={2}>
                    <Grid item xs={6}>
                        <Button onClick={openBookingEditDialog} variant={"outlined"} fullWidth>
                            {t("bookings.BookingManageDialog.editBooking")}
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <OfferReadOnlyButton offerId={booking.offer?.id} />
                    </Grid>
                </Grid>
                <Grid item>
                    <Button onClick={handleTransformToAgreement} variant={"outlined"} fullWidth>
                        {t("bookings.BookingManageDialog.transformToAgreement")}
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        onClick={openCancelBookingDialog}
                        variant={"outlined"}
                        color={"error"}
                        fullWidth
                    >
                        {t("bookings.BookingManageDialog.cancelBooking")}
                    </Button>
                </Grid>
            </Grid>
        </BasicDialog>
    );
};
